export const datagridColors = (width, isMobile) => {

  const returnValue = {
    '& .MuiDataGrid-columnHeaderTitle': {
      fontWeight: 800,
      fontSize: '13px',
      color: '#f9f9f9',
    },
    '& .textPrimary': {
      color: 'text.primary',
    },
    '& .MuiDataGrid-row.Mui-selected .MuiChip-label': {
      color: '#0053a5',
    },

    width: 'auto',
    '& .MuiDataGrid-virtualScroller': {
      minHeight: '32px',
      height: 'auto',
    },
    '& .MuiDataGrid-actionsCell': {
      gridGap: '0px !important',
    },
    '& .MuiDataGrid-actionsCell .MuiIconButton-root': {
      padding: '1px !important',
    },
    '& .MuiTablePagination-selectLabel': {
      display: 'none !important',
    },
    '& .MuiTablePagination-root .MuiTablePagination-input': {
      marginRight: '8px !important',
    },
    '& .MuiTablePagination-toolbar .MuiTablePagination-actions': {
      marginLeft: '0px !important',
    },
    '& .MuiDataGrid-menuIcon': {
      marginRight: '0px !important',
    },
    '& .multiselect-field .MuiAutocomplete-clearIndicator': {
      display: 'none',
    },

    '& .multiselect-field .MuiAutocomplete-hasClearIcon .MuiAutocomplete-inputRoot': {
      paddingRight: '35px !important',
    },

    '& .MuiDataGrid-row .MuiDataGrid-cell.MuiDataGrid-cell--editing .MuiChip-label': {
      maxWidth: '120px',
      paddingRight: '5px',
      paddingLeft: '5px',
    },

    '& .multiselect-field .MuiAutocomplete-hasPopupIcon .MuiOutlinedInput-root': {
      minWidth: '100px',
    },
    '& .MuiDataGrid-cell': {
      padding: '0px 6px',
      boxShadow: `1px 0px 0px #efefef`,
      overflow: `hidden`,
    },
    '& .MuiDataGrid-editInputCell input': {
      padding: '0px 6px',
    },
    '& .MuiChip-root': {
      height: '28px',
    },
    '& .MuiDataGrid-root .MuiDataGrid-cell.MuiDataGrid-cell--editing': {
      padding: '0px !important',
      borderBottom: '1px solid #e7d378',
      borderTop: '1px solid #e7d378',
      borderLeft: '1px solid #e7d37854',
    },

    '& .MuiDataGrid-root .MuiDataGrid-cell.MuiDataGrid-cell--editing .MuiOutlinedInput-input': {
      padding: '1px 2px !important',
      fontSize: '14px',
    },

    '& .MuiDataGrid-root .MuiDataGrid-cell.MuiDataGrid-cell--editing .MuiIconButton-root': {
      padding: '0px !important',
    },

    '& .MuiDataGrid-root .MuiDataGrid-cell.MuiDataGrid-cell--editing .MuiInputAdornment-root': {
      marginLeft: '0px !important',
    },

    '& .MuiAutocomplete-root .MuiOutlinedInput-root.MuiInputBase-sizeSmall .MuiAutocomplete-input': {
      padding: '2px',
    },
    '& .MuiDataGrid-columnHeaders .MuiDataGrid-columnHeader': {
      padding: '0px 6px',
    },
    '& .MuiDataGrid-row.odd': {
      backgroundColor: '#f5f5f5',
      '&:hover, &.Mui-hovered': {
        backgroundColor: 'rgb(0 0 0 / 8%)!important',
        '@media (hover: none)': {
          backgroundColor: 'transparent',
        },
      },
    },
    '& .MuiDataGrid-row.summary-row': {
      backgroundColor: '#fff',
      boxShadow: 'inset 0px 5px 9px -2px #0000001c',
      pointerEvents: 'none',
      '&:hover, &.Mui-hovered': {
        backgroundColor: '#e9f3ff!important',
        '@media (hover: none)': {
          backgroundColor: 'transparent',
        },
      },
    },
    '& .MuiDataGrid-row.summary-row svg': {
      display: 'none',
    },
    '& .MuiDataGrid-row.even': {
      backgroundColor: '#fff',
      '&:hover, &.Mui-hovered': {
        backgroundColor: 'rgb(0 0 0 / 8%)!important',
        '@media (hover: none)': {
          backgroundColor: 'transparent',
        },
      },
    },
    '& .blue-colored-cell': {
      backgroundColor: 'rgba(199,234,255,0.53)',
    },
    '& .green-colored-cell': {
      backgroundColor: 'rgb(199 255 219 / 53%)',
    },
    '& .row-color-1': {
      backgroundColor: 'rgb(71 185 229 / 26%)',
    },
    '& .row-color-2': {
      backgroundColor: 'rgb(255 217 197 / 52%)',
    },
    '& .row-color-3': {
      backgroundColor: 'rgb(238 197 255 / 52%)',
    },
    '& .row-color-4': {
      backgroundColor: 'rgb(255 241 168 / 52%)',
    },

    '& .cell-color-1': {
      backgroundColor: 'rgb(71 185 229 / 26%)',
    },
    '& .cell-color-2': {
      backgroundColor: 'rgb(255 217 197 / 52%)',
    },
    '& .cell-color-3': {
      backgroundColor: 'rgb(238 197 255 / 52%)',
    },
    '& .cell-color-4': {
      backgroundColor: 'rgb(255 241 168 / 52%)',
    },
    '& .cell-color-5': {
      backgroundColor: 'rgb(255 168 168 / 52%)',
    },
    '& .dark-cell-color-1': {
      backgroundColor: 'rgb(71 185 229 / 16%)',
    },
    '& .dark-cell-color-2': {
      backgroundColor: 'rgb(255 217 197 / 32%)',
    },
    '& .dark-cell-color-3': {
      backgroundColor: 'rgb(238 197 255 / 32%)',
    },
    '& .dark-cell-color-4': {
      backgroundColor: 'rgb(255 241 168 / 32%)',
    },
    '& .dark-cell-color-5': {
      backgroundColor: 'rgb(255 168 168 / 32%)',
    },
    '& .MuiDataGrid-root': {
      padding: '0px 0px',
      paddingTop: '0px',
      border: 'none',
      height: 'auto',
      maxHeight: 'calc(100% + 8px)',
    },
    '& .MuiDataGrid-main': {
      borderRadius: '10px',
      color: '#515151',
      boxShadow:
        'rgba(145, 158, 171, 0.2) 0px 0px 2px 0px, rgb(145 158 171 / 24%) 1px 3px 16px 2px',
    },
    '& .MuiDataGrid-topContainer': {
      backgroundColor: '#256861',
      color: '#f9f9f9',
    },
    '& .actions': {
      color: '#6b6b6b',
      fontWeight: 'bold',
    },
    '& .actions *': {
      color: '#6b6b6b',
    },
    '& .MuiDataGrid-columnHeader .MuiDataGrid-columnSeparator': {
      color: '#ededed',
      visibility: 'visible',
      display: 'block',
    },
    '& .MuiDataGrid-withBorderColor': {
      borderColor: '#ededed',
    },
    '& .MuiDataGrid-root .MuiDataGrid-columnHeader:focus, .MuiDataGrid-root .MuiDataGrid-columnHeader:focus-within': {
      outline: 'none',
    },
    '& .MuiDataGrid-root .MuiDataGrid-row--editing .MuiDataGrid-cell': {
      background: '#f7f0b9!important',
    },
    '& .MuiDataGrid-root .MuiDataGrid-row--editing.Mui-hovered .MuiDataGrid-cell': {
      background: '#fdfded!important',
    },
    '& .MuiTableCell-root .MuiCollapse-root': {
      overflow: 'hidden',
    },
    '& .MuiDataGrid-root .MuiDataGrid-columnHeader': {
      padding: '0px 6px',
    },
    '& .MuiDataGrid-columnHeader .MuiButtonBase-root.MuiIconButton-root': {
      padding: '0px !important',
      background: 'transparent',
    },

    '& .MuiDataGrid-root .MuiDataGrid-columnSeparator--resizable:hover': {
      color: 'rgb(94 183 239)',
    },

    '& .MuiDataGrid-root .MuiDataGrid-columnHeader .MuiDataGrid-iconButtonContainer': {
      position: 'absolute',
      bottom: '0px',
      left: '50%',
      transform: 'translateX(-50%)',
      pointerEvents: 'none',
      display: isMobile ? 'none' : 'block',
    },
    '& .MuiDataGrid-root .MuiDataGrid-menuOpen svg.MuiSvgIcon-root': {
      width: '0px',
      fontSize: '0px',
    },
    '& .MuiDataGrid-editBooleanCell .MuiCheckbox-root': {
      padding: '0px',
    },

    '& .MuiDataGrid-columnHeaders': {
      background: '#256861',
      color: '#fefefe',
    },
    '& .MuiDataGrid-pinnedColumnHeaders': {
      background: '#1a5c55',
      boxShadow: 'none',
    },
    '& .MuiDataGrid-root .MuiDataGrid-cell': {
      minHeight: '32px',
    },

    '& .MuiDataGrid-root .MuiDataGrid-row.Mui-selected,  .MuiDataGrid-root .MuiDataGrid-pinnedColumns .MuiDataGrid-row.Mui-selected': {
      background: 'rgb(249 224 49 / 32%) !important',
    },


    '& .MuiDataGrid-root .MuiDataGrid-columnHeader .MuiIconButton-root .MuiSvgIcon-root': {
      color: '#fff',
    },

    '& .MuiDataGrid-root .MuiDataGrid-row.light-blue': {
      background: 'rgb(37 106 94 / 13%)',
    },

    '& .MuiDataGrid-root .MuiDataGrid-row.light-blue-header': {
      background: 'rgb(37 106 94 / 19%)',
    },

    '& .MuiDataGrid-root .MuiDataGrid-cell.sub-row': {
      paddingLeft: '30px !important',
    },

    '& .MuiDataGrid-root .MuiDataGrid-footerContainer': {
      minHeight: '41px',
    },
    '& .MuiDataGrid-root .MuiTablePagination-toolbar': {
      minHeight: '41px',
    },

    '& .MuiDataGrid-root .MuiButtonBase-root.MuiChip-root': {
      padding: '4px',
    },

    '& .MuiDataGrid-root .MuiDataGrid-headerFilterRow': {
      background: '#fff',
      border: 'none',
    },
    '& .MuiDataGrid-headerFilterRow .MuiDataGrid-columnHeader': {
      padding: '0px 3px',
      background: '#256861',
      boxShadow: 'inset 0px 0px 1px 0px #ffffff8f',
    },

    '& .MuiDataGrid-headerFilterRow .MuiDataGrid-columnHeader .MuiFormControl-root': {
      width: '100%',
      background: '#fafafa',
      borderRadius: '3px',
      border: '1px solid #c0c0c0',
      paddingLeft: '4px',
    },

    '& .MuiDataGrid-headerFilterRow .MuiInputBase-root.MuiInput-root:after, .MuiDataGrid-headerFilterRow .MuiInputBase-root.MuiInput-root:before': {
      display: 'none',
    },

    '& .MuiDataGrid-columnHeader .MuiBox-root': {
      paddingLeft: '0px',
      height: 'auto',
      width: '100%',
    },
    '& .MuiDataGrid-columnHeader .MuiInputBase-root.MuiInput-root': {
      marginTop: '0px',
    },
    '& .MuiDataGrid-columnHeader .MuiBox-root .MuiOutlinedInput-root': {
      padding: '2px',
    },
    '& .MuiDataGrid-headerFilterRow .MuiInputBase-root.MuiInput-root > input': {
      padding: '2.5px 2px',
      fontSize: '12px',
      lineHeight: '14px',
    },

    '& .MuiDataGrid-headerFilterRow .MuiInputBase-root.MuiInput-root > select': {
      paddingY: '2px',
      fontSize: '12px',
      lineHeight: '14px',
    },

    '& .MuiDataGrid-columnHeader .MuiFormLabel-root.MuiInputLabel-root': {
      display: 'none',
    },

    '& .MuiDataGrid-columnHeader .MuiAutocomplete-root .MuiAutocomplete-inputRoot .MuiAutocomplete-input': {
      padding: '0px',
      fontSize: '12px',
      lineHeight: '14px',
    },

    '& .MuiDataGrid-columnHeader .MuiAutocomplete-root': {
      display: 'flex',
      alignItems: 'center',
    },

    '& .MuiDataGrid-columnHeader .MuiAutocomplete-root .MuiFormControl-root': {
      padding: '0px',
    },

    '& .MuiDataGrid-columnHeader .MuiAutocomplete-root .MuiIconButton-root .MuiSvgIcon-root': {
      color: '#666',
      height: '20px',
      width: '20px',
    },
    '& .MuiDataGrid-columnHeader .MuiAutocomplete-root .MuiOutlinedInput-root': {
      padding: '2.5px 2px',
      paddingRight: '40px',
    },

    '& .MuiDataGrid-columnHeader .MuiAutocomplete-root .MuiOutlinedInput-notchedOutline': {
      border: 'none',
      borderRadius: '0px',
    },

    '& .MuiDataGrid-columnHeader .MuiButtonBase-root.MuiCheckbox-root': {
      color: '#fff',
    },

    '& .MuiDataGrid-overlay': {
      minHeight: '30px',
      height: '100%',
    },

    '& .MuiButtonBase-root.MuiChip-root': {
      padding: '2px 0px',
      borderRadius: '5px',
      height: '22px',
    },
    '& .MuiDataGrid-root .MuiDataGrid-cell:focus': {
      outline: 'solid #9c1111 2px',
      outlineOffset: '-2px',
    },
    '& .MuiDataGrid-columnHeader .MuiOutlinedInput-notchedOutline': {
      border: 'none'
    },
    '& .MuiDataGrid-columnHeader .MuiInputBase-input.MuiOutlinedInput-input': {
      padding: '0px'
    },

    '& .MuiDataGrid-columnHeader .MuiInputBase-root .MuiIconButton-root .MuiSvgIcon-root': {
      color: '#999'
    },

    '& .MuiDataGrid-root .MuiDataGrid-columnHeader .MuiDataGrid-menuIcon': {
      visibility: isMobile ? 'hidden' : 'auto',
      pointerEvents: 'none',
      width: '0px',
    },

    padding: '0px 10px',
    marginTop: '5px',
  };

  if (!isMobile){
    returnValue['height'] = `${width ? width : 'calc(100% - 110px)'}`;
    returnValue['maxHeight'] = `${width ? width : 'calc(100% - 110px)'}`;
  }

  return returnValue;
};
